import Vue from 'vue';
import Vuex from 'vuex';

// tslint:disable-next-line: no-var-requires
const path = require('path');

import { viewStore } from './view';
import app from './modules/app';
import currentUser from './modules/current-user';

Vue.use(Vuex);

/********************************自动导包 start********************************/
const file = require.context('./modules', true, /\module.ts/);

const modules: { [propsName: string]: any } = {};
file.keys().forEach((key: string) => {
  const name = path.normalize(path.dirname(key));

  modules[name] = file(key).default || file(key);
});


/********************************自动导包 end********************************/

//Vue.use(Vuex);
// import app from './modules/shared/app'
// import session from './modules/system/session'
// import account from './modules/system/account'
// import user from './modules/system/user'
// import role from './modules/system/role'
// import tenant from './modules/system/tenant'

const store = new Vuex.Store({
    modules: {
        app,
        currentUser,
        viewStore,
        ...modules
    }
});
export default store;